import React from 'react';
import Responsive from 'react-responsive';
import { CssBaseline } from '@material-ui/core';

import DesktopLayoutSkeleton from './desktop/DesktopLayoutSkeleton';
import MobileLayoutSkeleton from './mobile/MobileLayoutSkeleton';

import { MOBILE_WIDTH } from './../../constants/Layout';

const Desktop = (props) => (
  <Responsive {...props} minWidth={MOBILE_WIDTH + 1} />
);
const Mobile = (props) => <Responsive {...props} maxWidth={MOBILE_WIDTH} />;

const SkeletonLayout = () => {
  return (
    <React.Fragment>
      <CssBaseline />
      <Desktop>
        <DesktopLayoutSkeleton />
      </Desktop>
      <Mobile>
        <MobileLayoutSkeleton />
      </Mobile>
    </React.Fragment>
  );
};

export default SkeletonLayout;
